module.exports = __webpack_public_path__ + "img/Main4.d537036f.jpg";